<!-- <model-viewer
  *ngIf="url"
  camera-controls
  camera-orbit="45deg 55deg 2.5m"
  [src]="url"
  alt="A 3D model of an astronaut"
  data-js-focus-visible=""
  ar-status="not-presenting"
>
</model-viewer> -->

<model-viewer
  [src]="url"
  ar
  ar-modes="webxr scene-viewer quick-look"
  camera-controls
  poster="poster.webp"
  shadow-intensity="1"
>
  <div class="progress-bar hide" slot="progress-bar">
    <div class="update-bar"></div>
  </div>
  <button slot="ar-button" id="ar-button">{{ "models3d.view-in-your-space" | translate }}</button>
  <div id="ar-prompt">
    <img src="https://modelviewer.dev/shared-assets/icons/hand.png" />
  </div>
</model-viewer>

<!-- <div *ngIf="fileHtml" [innerHtml]="fileHtml"></div> -->
